<template>
  <span class="b44-health-badge" :class="cfg.className">
    <span class="dot"></span>
    {{ cfg.label }}
  </span>
</template>

<script>
const CONFIG = {
  vermelho: { label: "Risco", className: "vermelho" },
  amarelo: { label: "Atenção", className: "amarelo" },
  verde: { label: "Saudável", className: "verde" },
};

export default {
  name: "HealthBadge",
  props: { saude: { type: String, default: "verde" } },
  computed: {
    cfg() {
      return CONFIG[this.saude] || CONFIG.verde;
    },
  },
};
</script>
